var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.545 5.4753L19.337 2.74291L20.0253 3.43212L6.83654 16.3404C6.66453 16.5088 6.45622 16.6354 6.22762 16.7106L2.42021 17.9519C2.03632 18.0799 1.61306 17.9802 1.32664 17.6943C1.0439 17.4159 0.945794 17 1.07428 16.6245L2.34374 12.898C2.42178 12.6715 2.55099 12.4661 2.72132 12.2977L14.827 0.449777C15.4419 -0.14667 16.4194 -0.14667 17.0343 0.449777L18.5006 1.88509L17.8124 2.57434L16.346 1.13903C16.1144 0.915112 15.7469 0.915112 15.5153 1.13903L13.8151 2.80303L16.545 5.4753ZM0 19.0003H20V20.0003H0V19.0003ZM3.41054 12.987C3.34733 13.0485 3.29951 13.1241 3.27097 13.2076L2.00152 16.9341L2.11432 17.0316L5.91982 15.7894C6.00529 15.7615 6.08315 15.7142 6.14732 15.6512L15.8487 6.15697L13.1189 3.48469L3.41054 12.987Z",
    fill: "#0E5AA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.de73eeb054bce42f851aa7b7aafa81ed.svg";
export { ForwardRef as ReactComponent };